<fieldset class="in-one-column" [formGroup]="group">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- childrenChampagne -->

  <mat-form-field *ngIf="getCtrl('childrenChampagne')">
    <app-easy-checkbox
      formControlName="childrenChampagne"
      [label]="TITLE + 'CHILDREN_CHAMPAGNE' | translate"
      (ngModelChange)="onChildrenChampagneChange($event)"
    ></app-easy-checkbox>
  </mat-form-field>

  <div class="in-two-columns">
    <!-- childrenChampagneflavors -->

    <mat-form-field *ngIf="getCtrl('childrenChampagneflavors')">
      <app-easy-select
        formControlName="childrenChampagneflavors"
        [label]="TITLE + 'CHILDREN_CHAMPAGNE_FLAVORS' | translate"
        [translatePrefixForSelected]="'PRODUCTS.FLAVOR_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [multiple]="true"
        [options]="
          childrenChampagneflavors
            | toSelectOption: 'PRODUCTS.FLAVOR_TYPE.':true
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- qualityType -->

    <mat-form-field>
      <app-easy-select
        formControlName="qualityType"
        [label]="TITLE + 'QUALITY_TYPE' | translate"
        [translatePrefixForSelected]="
          'PRODUCTS.CHAMPAGNE_PROPERTIES.QUALITY_TYPE.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          qualityType
            | toSelectOption: 'PRODUCTS.CHAMPAGNE_PROPERTIES.QUALITY_TYPE.'
        "
        (ngModelChange)="onQualityTypeChange($event)"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- oemType -->

    <mat-form-field *ngIf="getCtrl('oemType')">
      <app-easy-select
        formControlName="oemType"
        [label]="TITLE + 'OEM_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.CHAMPAGNE_PROPERTIES.OEM_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          oemType | toSelectOption: 'PRODUCTS.CHAMPAGNE_PROPERTIES.OEM_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- ofjType -->

    <mat-form-field *ngIf="getCtrl('ofjType')">
      <app-easy-select
        formControlName="ofjType"
        [label]="TITLE + 'OFJ_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.CHAMPAGNE_PROPERTIES.OFJ_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          ofjType | toSelectOption: 'PRODUCTS.CHAMPAGNE_PROPERTIES.OFJ_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- year -->

    <mat-form-field>
      <app-easy-input
        formControlName="year"
        [label]="TITLE + 'YEAR' | translate"
        type="number"
        step="1"
        min="1980"
        [max]="currentYear"
      >
      </app-easy-input>
    </mat-form-field>

    <!-- champagenColor -->

    <mat-form-field>
      <app-easy-select
        formControlName="champagneColor"
        [label]="TITLE + 'CHAMPAGNE_COLOR' | translate"
        [translatePrefixForSelected]="
          'PRODUCTS.CHAMPAGNE_PROPERTIES.CHAMPAGNE_COLOR.'
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          champagneColor
            | toSelectOption: 'PRODUCTS.CHAMPAGNE_PROPERTIES.CHAMPAGNE_COLOR.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- nature -->

    <mat-form-field>
      <app-easy-select
        formControlName="nature"
        [label]="TITLE + 'NATURE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.CHAMPAGNE_NATURE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          champagneNature | toSelectOption: 'PRODUCTS.CHAMPAGNE_NATURE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- fermentationType -->

    <mat-form-field *ngIf="getCtrl('fermentationType')">
      <app-easy-select
        formControlName="fermentationType"
        [label]="TITLE + 'FERMENTATION_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.CHAMPAGNE_FERMENTATION_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          champagneFermentationType
            | toSelectOption: 'PRODUCTS.CHAMPAGNE_FERMENTATION_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>

    <!-- basicWineType -->

    <mat-form-field *ngIf="getCtrl('basicWineType')">
      <app-easy-select
        formControlName="basicWineType"
        [label]="TITLE + 'BASIC_WINE_TYPE' | translate"
        [translatePrefixForSelected]="'PRODUCTS.CHAMPAGNE_BASIC_WINE_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          champagneBasicWineType
            | toSelectOption: 'PRODUCTS.CHAMPAGNE_BASIC_WINE_TYPE.'
        "
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <!-- flavoured -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="flavored"
      [label]="TITLE + 'FLAVORED' | translate"
    ></app-easy-checkbox>
  </mat-form-field>
</fieldset>
